var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-item',{attrs:{"card":"item_homework","tabs":_vm.tabs,"activeTab":_vm.activeTab,"id":_vm.id,"infoKeys":_vm.infoKeys}})
}
var staticRenderFns = []

export { render, staticRenderFns }